<div class="wrapper">
  <div class="title">{{'musicChannel.label.title' | translate }}</div>
  @if ((musicChannelsLoading$ | async)) {
    <div class="loaderContainer">
      <mat-spinner class="loading-spinner"></mat-spinner>
      <span class="loadingText">{{'general.status.loading' | translate}}</span>
    </div>
  }
  @if ((musicChannelsLoadingError$ | async)) {
    <div class="errorContainer">
      <p>{{'general.status.error.message' | translate}}</p>
      <button (click)="onRetry()" class="retryButton">
        <p>
          {{'general.status.error.retry' | translate }}
        </p>
      </button>
    </div>
  }
  @if (!(musicChannelsLoading$ | async) && !(musicChannelsLoadingError$ | async)) {
    <div class="scrollContainer">
      @for (musicChannelGroup of (musicChannelGroups$ | async); track musicChannelGroup; let i = $index) {
        <tun-music-channel-group-view
          class="musicChannelGroup {{ i == 0 ? 'first' : ''}}"
          [musicChannelGroup]="musicChannelGroup"
          (showDetails)="onShowDetails($event)"
          [playButtonShowStragegy]="ON_HOVER"
        ></tun-music-channel-group-view>
      }
    </div>
  }
</div>
